import { lazy, Suspense, useState } from 'react';
import type { Yo } from './services/api';
import { alTocar, useRuta } from './components/ruta';
import { Portada } from './screens/Portada';
import { TorneoPublico } from './screens/TorneoPublico';
import { Admin } from './screens/admin/Admin';
import { InstalarApp } from './components/InstalarApp';
import { Marca } from './components/Marca';

const DemoPlacas = import.meta.env.DEV ? lazy(() => import('./components/DemoPlacas')) : null;
const GuiaOrganizador = lazy(() => import('./screens/GuiaOrganizador').then(m => ({ default: m.GuiaOrganizador })));
const DemoTorneo = lazy(() => import('./screens/DemoTorneo').then(m => ({ default: m.DemoPagina })));

// Dos mundos: lo publico (cualquiera con el link) y /admin (organizadores).
export function App() {
  const ruta = useRuta();
  const [usuarioAdmin, setUsuarioAdmin] = useState<Yo | null>(null);

  if (DemoPlacas && ruta === '/demo/placas') return <Suspense fallback={<p>Preparando estudio…</p>}><DemoPlacas /></Suspense>;
  if (ruta === '/demo' || ruta === '/demo/') return <Suspense fallback={<p className="p-6 text-center">Preparando el torneo de ejemplo…</p>}><DemoTorneo /></Suspense>;

  const esAdmin = ruta === '/admin' || ruta.startsWith('/admin/');
  const esGuia = ruta === '/guia-organizador' || ruta === '/guia-organizador/';
  const torneo = ruta.match(/^\/t\/([a-z0-9-]+)\/?$/);
  if (!esAdmin && !esGuia && !torneo) return <Portada />;
  return <>
    <header aria-label="EnCancha" className="cabecera-app sticky top-0 z-30 h-14 border-b border-(--color-borde) bg-(--color-panel)">
      <div className="mx-auto flex h-full max-w-2xl items-center justify-between gap-3 px-4">
        <a href="/" onClick={alTocar('/')} className="min-w-0 shrink text-2xl font-bold tracking-tight text-(--color-texto) focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-(--color-acento) [&_img]:h-auto [&_img]:max-w-full">
          <Marca />
        </a>
        {esAdmin && usuarioAdmin && (
          <div className="min-w-0 max-w-[45%] text-right leading-tight">
            <p className="truncate text-[11px] font-bold uppercase tracking-widest text-(--color-acento)" title={usuarioAdmin.organizacion}>{usuarioAdmin.organizacion}</p>
            <p className="truncate text-sm text-(--color-apagado)" title={usuarioAdmin.organizador.nombre}>{usuarioAdmin.organizador.nombre}</p>
          </div>
        )}
      </div>
    </header>
    {esGuia ? <Suspense fallback={<p className="p-6 text-center">Cargando guía…</p>}><GuiaOrganizador /></Suspense> : esAdmin ? <Admin ruta={ruta} onUsuarioChange={setUsuarioAdmin} /> : torneo ? <TorneoPublico slug={torneo[1]!} /> : <Portada />}
    {!esGuia && <InstalarApp />}
  </>;
}
